"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const shopLandingPageInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Shop",
    friendlyName: "Title",
  },
  {
    name: "subtitle",
    type: "string",
    required: false,
    defaultValue: "",
    friendlyName: "Subtitle",
  },
  {
    name: "shopPageTeasers",
    type: "list",
    friendlyName: "Shop Page Teasers",
    defaultValue: [],
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
        defaultValue: "Teaser Title",
        friendlyName: "Teaser Title",
      },
      {
        name: "path",
        type: "url",
        required: true,
        defaultValue: "#",
        friendlyName: "Link Path",
      },
      {
        name: "backgroundImage",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
        friendlyName: "Background Image",
      },
      {
        name: "relatedLanguage",
        type: "string",
        required: false,
        defaultValue: "",
        friendlyName: "Related Language",
      },
    ],
  },
] as const satisfies Inputs;

export const ShopLandingPageComponent: RegisteredComponent = {
  name: "ShopLandingPage",
  component: dynamic(async () =>
    withValidation(shopLandingPageInputs, (await import("./ShopLandingPage")).ShopLandingPage, "ShopLandingPage")
  ),
  inputs: shopLandingPageInputs,
};
